import React from "react";
import { Row, Col } from "reactstrap";
import "leaflet/dist/leaflet.css";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getDriverById } from "../../Drivers/services/driverApi";
import avatar1 from "../../../assets/images/users/avatar-user.png";
import { Spin } from "antd";
import { getInspection } from "../../Inspection/services/inspectionsApi";
import { getVehicleById } from "../services/vehiculeApi";

const VehicleResume = () => {
  const { id } = useParams();
  const {
    data: vehicle,
    isLoading,
    isError,
    error,
  } = useQuery(["vehicule", id], () => getVehicleById(id));
  const { data: inspections = [] } = useQuery("inspections", getInspection);
  const vehicleInspections = inspections.filter(
    (inspection) => inspection.vehicle?.id === parseInt(id)
  );

  const treatedCount = vehicleInspections.filter(
    (ins) => ins.status === "Traité"
  ).length;

  const pendingCount = vehicleInspections.filter(
    (ins) => ins.status === "En attente"
  ).length;
  const archivedCount = vehicleInspections.filter(
    (ins) => ins.status === "Archivé"
  ).length;

  const filteredIncidents = vehicleInspections.filter(
    (inspection) => inspection.typeInspection === "Incident"
  );
  const treatedCountIncident = filteredIncidents.filter(
    (ins) => ins.type === "Traité"
  ).length;
  const pendingCountIncident = filteredIncidents.filter(
    (ins) => ins.status === "En attente"
  ).length;
  const archivedCountIncident = filteredIncidents.filter(
    (ins) => ins.status === "Archivé"
  ).length;
  const {
    data: user,
    isLoadingUser: userLoading,
    isErrorUser: userError,
    errorUser: userErrorMsg,
  } = useQuery(
    ["user", vehicle?.actualUserId],
    () => getDriverById(vehicle?.actualUserId),
    {
      enabled: !!vehicle?.actualUserId,
    }
  );

  const getStatusColor = (statut) => {
    switch (statut) {
      case "En service":
      case "En service #2FB550":
      case "Actif #2FB550":
        return "#2FB550";
      case "Hors service":
        return " #FF2D55";
      default:
        return " #FF9500";
    }
  };
  return (
    <div className="row ">
      <div className="container" style={{ marginTop: "30px" }}>
        <div className="row">
          {/* Première carte */}

          <div className="col-6">
            <div className="card" style={{ height: "100%" }}>
              <div className="card-body">
                {/* <div style={{ height: "20px" }}></div> */}
                <div className="row">
                  <div className="col-12 text-start">
                    <h5 className="card-title">Spécifications</h5>
                  </div>
                </div>

                {/* N° Immatriculation */}
                <div className="row mt-3">
                  <div className="col-6">
                    <p className="card-text">N° Immatriculation</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">{vehicle?.registrationNumber}</p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                {/* Contenu avec deux colonnes */}
                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Nom du véhicule</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.model || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Marque</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.brand || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Transmission</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.transmission || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Vitesse</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.speed || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Numéro d'Identification</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.vin || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Date de mise en service</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.commissioningDate || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Statut</p>
                  </div>
                  <div className="col-6 d-flex align-items-center">
                    <span
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: getStatusColor(vehicle?.statut),
                        marginRight: "8px",
                      }}
                    ></span>
                    <p className="card-text">
                      {vehicle?.statut || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Couleurs du vehicule</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.color || "Non disponible"}
                    </p>
                  </div>
                </div>
                <hr style={{ margin: "10px 0" }} />

                <div className="row">
                  <div className="col-6">
                    <p className="card-text">Description</p>
                  </div>
                  <div className="col-6">
                    <p className="card-text">
                      {vehicle?.description || "Non disponible"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Deuxième carte */}
          <div className="col-6">
            <div className="card" style={{ height: "100%" }}>
              <div className="card-body">
                {/* Première sous-carte */}
                <div className="col-12 mb-3">
                  <div className="card">
                    <div className="card-header">
                      <div className="col-12 text-start">
                        <h5 className="card-title">Inspections</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <Row>
                        <Col
                          className="text-start"
                          md={4}
                          style={{
                            borderRight: "1px solid #ccc",
                            paddingRight: "15px",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {" "}
                          {treatedCount}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            Traités
                          </span>
                        </Col>
                        <Col
                          className="text-center"
                          md={4}
                          style={{
                            borderRight: "1px solid #ccc",
                            paddingRight: "15px",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {pendingCount}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            En attente
                          </span>
                        </Col>
                        <Col
                          className="text-center"
                          md={4}
                          style={{
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {archivedCount}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            Archivés
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>

                {/* Deuxième sous-carte */}
                <div className="col-12 mb-3">
                  <div className="card">
                    <div className="card-header">
                      <div className="col-12 text-start">
                        <h5 className="card-title">Incidents</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <Row>
                        <Col
                          className="text-start"
                          md={4}
                          style={{
                            borderRight: "1px solid #ccc",
                            paddingRight: "15px",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {" "}
                          {treatedCountIncident}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            Traités
                          </span>
                        </Col>
                        <Col
                          className="text-center"
                          md={4}
                          style={{
                            borderRight: "1px solid #ccc",
                            paddingRight: "15px",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {pendingCountIncident}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            En attente
                          </span>
                        </Col>
                        <Col
                          className="text-center"
                          md={4}
                          style={{
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontWeight: "500px",
                            color: "#252525",
                          }}
                        >
                          {archivedCountIncident}
                          <br></br>
                          <span
                            style={{
                              color: "#868686",
                              fontSize: "14px",
                              fontFamily: "Inter",
                              weight: "400px",
                            }}
                          >
                            Archivés
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>

                {/* Troisième sous-carte */}
                <div className="col-12 mb-3">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-12 text-start">
                          <h5 className="card-title">Kilométrages</h5>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <p className="card-text">{vehicle?.mileage} Km</p>
                      <span>Parcourus avec {user?.name || "-"}</span>
                      <div>
                        <vehiclePosition />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container " style={{ marginTop: "20px" }}></div>
    </div>
  );
};

export default VehicleResume;
